import { useApp } from '@/context/AppContext';

function todayStr() {
  return new Date().toISOString().slice(0, 10);
}

export default function AddStopModal({ data }) {
  const { addStop, closeModal, customers, team } = useApp();

  const handleSubmit = (e) => {
    e.preventDefault();
    const fd = new FormData(e.target);
    const f = Object.fromEntries(fd);
    addStop({
      custId: Number(f.custId),
      tech:   f.tech,
      date:   f.date,
      time:   f.time,
      notes:  f.notes || '',
    });
    closeModal();
  };

  if (customers.length === 0) {
    return (
      <div className="modal">
        <div className="modal-head">
          <span className="modal-title">Schedule a Stop</span>
          <button className="btn btn-ghost btn-sm" onClick={closeModal}>✕</button>
        </div>
        <div className="modal-body" style={{ textAlign: 'center', padding: '24px 16px' }}>
          <div style={{ fontSize: 13, color: 'var(--t2)', marginBottom: 12 }}>
            You need at least one customer before scheduling a stop.
          </div>
          <button className="btn btn-ghost" onClick={closeModal}>Close</button>
        </div>
      </div>
    );
  }

  const defaultCustId = data?.custId || customers[0]?.id || '';
  const defaultTech   = data?.tech || (team[0]?.name || '');

  return (
    <div className="modal">
      <div className="modal-head">
        <span className="modal-title">Schedule a Stop</span>
        <button className="btn btn-ghost btn-sm" onClick={closeModal}>✕</button>
      </div>
      <div className="modal-body">
        <form onSubmit={handleSubmit}>
          <div className="field">
            <label>Customer *</label>
            <select name="custId" required defaultValue={defaultCustId}>
              {customers.map(c => (
                <option key={c.id} value={c.id}>{c.name} — {c.addr}</option>
              ))}
            </select>
          </div>
          <div className="form-row">
            <div className="field">
              <label>Date *</label>
              <input name="date" type="date" required defaultValue={data?.date || todayStr()} />
            </div>
            <div className="field">
              <label>Time *</label>
              <input name="time" type="time" required defaultValue={data?.time || '09:00'} />
            </div>
          </div>
          <div className="field">
            <label>Assigned Tech *</label>
            <select name="tech" required defaultValue={defaultTech}>
              {team.length === 0 && <option value="">— No technicians yet —</option>}
              {team.map(t => <option key={t.id} value={t.name}>{t.name}</option>)}
            </select>
            {team.length === 0 && (
              <div style={{ fontSize: 11, color: 'var(--rose)', marginTop: 4 }}>
                Add a technician in the Team screen first.
              </div>
            )}
          </div>
          <div className="field">
            <label>Notes</label>
            <textarea name="notes" placeholder="Anything the tech should know…" />
          </div>
          <div className="modal-foot">
            <button type="button" className="btn btn-ghost" onClick={closeModal}>Cancel</button>
            <button type="submit" className="btn btn-primary" disabled={team.length === 0}>
              Schedule Stop
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
